const _ = require('underscore');
const model = require('model/model');
const classService = require('services/classService');

const groupNameSorter = (a, b) => {
	let nameA = a.n.toLowerCase();
	let nameB = b.n.toLowerCase();
	let val = 0;

	if (nameA < nameB) {
		val = -1;
	} else if (nameA > nameB) {
		val = 1;
	}

	return val;
};

const getGroup = id => {
	let group = null;
	let groups = model.get('studentGroups');
	if (groups && groups.length) {
		groups.some(g => {
			if (g.id === id) {
				group = g;
				return true;
			}
			return false;
		});
	}
	return group;
};

const removeGroup = id => {
	let groups = model.get('studentGroups') || [];
	groups = groups.filter(g => g.id !== id);
	model.set('studentGroups', groups);
};

const updateGroup = group => {
	let id = group.id;
	let groups = null;

	removeGroup(id);
	groups = [...(model.get('studentGroups') || [])];
	group.u = Date.now() / 1000;
	groups.push(group);
	groups.sort(groupNameSorter);
	model.set('studentGroups', groups);
};

const fetchGroups = classCode => {
	let cc = classCode;
	return classService.getGroups({ cc }).then(groups => {
		groups = groups || [];
		groups = groups.sort(groupNameSorter);
		groups.map(g => {
			g.count = Object.keys(g.suids).length;
			return g;
		});
		model.set('studentGroups', groups);

		return groups;
	});
};

const createStudentGroup = (name, classCode, students) => {
	let n = name;
	let cc = classCode;
	let suids = students;

	return classService.createStudentGroup({ n, cc, suids }).then(g => {
		updateGroup(g);
		return g;
	});
};

const renameStudentGroup = (id, cc, name) => {
	let n = name;
	return classService.renameStudentGroup({ id, cc, n }).then(resp => {
		let group = null;
		if (resp && resp.ok) {
			group = getGroup(id);
			group.n = name;
			updateGroup(group);
		}
		return group;
	});
};

const addStudentsToGroup = (id, cc, suids, token) => {
	return classService.addStudentsToGroup({ id, cc, suids, token }).then(resp => {
		let group = getGroup(id);
		let suidsToAdd = Object.keys(suids);
		let suidMap = _.assign(group.suids);

		suidsToAdd.forEach(suid => (suidMap[suid] = true));
		group.suids = suidMap;

		updateGroup(group);
		return group;
	});
};

const removeStudentsFromGroup = (id, cc, suids, token) => {
	return classService.removeStudentsFromGroup({ id, cc, suids, token }).then(resp => {
		let group = getGroup(id);
		let suidsToRemove = Object.keys(suids);
		let suidMap = _.assign(group.suids);

		suidsToRemove.forEach(suid => delete suidMap[suid]);
		group.suids = suidMap;

		updateGroup(group);
		return group;
	});
};

const deleteGroup = (id, cc) => {
	return classService.deleteGroup({ id, cc }).then(resp => {
		if (resp && resp.ok) {
			let group = getGroup(id);
			removeGroup(id);
			return group;
		}
		return null;
	});
};

module.exports = {
	fetchGroups,
	createStudentGroup,
	renameStudentGroup,
	addStudentsToGroup,
	removeStudentsFromGroup,
	deleteGroup,
	groupNameSorter
};
